export const PRIMARY_FORM_SECTION = 1;
export const SECONDARY_FORM_SECTION = 2;
export default function getFormSection(typeID) {
  if (typeID === PRIMARY_FORM_SECTION) {
    return "entity-form-section-primary";
  } else {
    return "entity-form-section-secondary";
  }
}
